import Zh from '@/assets/i18n/zh.json'
import En from '@/assets/i18n/en.json'
import VueI18n from 'vue-i18n'//需先安装vue-i18n
import Vue from 'vue'

Vue.use(VueI18n)
let zh = Zh
let en = En
let messagesData = {
 zh: zh,
 en: en
}

let i18n = new VueI18n({
  locale: 'zh',
  messages: messagesData
})

const setLang = (lang) => {
  i18n.locale = lang
}
const getLang = () => {
  return i18n.locale
}


Vue.prototype.$setLang = setLang
Vue.prototype.$getLang = getLang

export default i18n



// WEBPACK FOOTER //
// ./src/config/i18nFn.js